import * as React from "react";
import ToggleButtons from "./ToggleButons";
import { Grid } from "@mui/material";
import { features } from "./data";
import { Item } from "./styledComponent";

const OrganizationVisibilityForm = ({ role, organizationIdentifier }) => {
  const id = React.useId();

  return (
    <>
      <Grid container spacing={2} sx={{ paddingBlock: 2 }}>
        <Grid xs={12} item>
          <Item elevation={0}>
            <h6 className="add-edit-patient-sub-header">
              Menu Item Visibility for {role}
            </h6>
          </Item>
        </Grid>
        {features.map(
          (item) =>
            item?.roles?.includes(role) && (
              <Grid xs={12} sm={6} md={4} item key={id + item?.feature}>
                <Item elevation={0}>
                  <ToggleButtons
                    label={item?.feature}
                    configKey={item?.configKey}
                    role={role}
                    organizationIdentifier={organizationIdentifier}
                  />
                </Item>
              </Grid>
            )
        )}
      </Grid>
    </>
  );
};
export default OrganizationVisibilityForm;
